// extracted by mini-css-extract-plugin
export default {"root":"PasswordRules_root__hzMVO","label":"PasswordRules_label__TdHSP","wrapper":"PasswordRules_wrapper__8Se-p"};